import { render } from "./UserIpLogManagement.vue?vue&type=template&id=1f4f4387&scoped=true"
import script from "./UserIpLogManagement.vue?vue&type=script&lang=js"
export * from "./UserIpLogManagement.vue?vue&type=script&lang=js"

import "./UserIpLogManagement.vue?vue&type=style&index=0&id=1f4f4387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4f4387"]])

export default __exports__